<template>
  <div class="preferences-block">
    <h5 class="subheading">{{ `app.interview.allergy_and_intolerance_products` | trans }}</h5>
    <span v-if="allergyProducts.length === 0">{{ `app.no_data`|trans }}</span>
    <v-layout row wrap>
      <v-flex xs6 v-for="product in allergyProducts" v-bind:key="product.id" class="no-padding">{{ product.name }}</v-flex>
    </v-layout>
    <h5 class="mt-4 subheading">{{ `app.interview.unlike_and_inadvisable_products` | trans }}</h5>
    <span v-if="unlikeProducts.length === 0">{{ `app.no_data`|trans }}</span>
    <v-layout row wrap>
      <v-flex xs6 v-for="product in unlikeProducts" v-bind:key="product.id" class="no-padding">{{ product.name }}</v-flex>
    </v-layout>
    <h5 class="mt-4 subheading">{{ `app.interview.like_products` | trans }}</h5>
    <span v-if="like.length === 0">{{ `app.no_data`|trans }}</span>
    <v-layout row wrap>
      <v-flex xs6 v-for="product in like" v-bind:key="product.id" class="no-padding">{{ product.name }}</v-flex>
    </v-layout>
    <h5 class="mt-4 subheading">{{ 'app.interview.other_allergy'|trans }}</h5>
    <span v-if="interview.other_allergy === null">{{ `app.no_data`|trans }}</span>
    <pre>{{ interview.other_allergy }}</pre>
  </div>
</template>
<script>
import { mapGetters} from "vuex";
import {TYPES, APPROACHES} from "../../../helpers/likeables";

export default {
  computed: {
    ...mapGetters(['interview', 'likeables']),
    allergyProducts: function () {
      return this.likeables.filter((likeable) => {
        return likeable.approach === APPROACHES.ALLERGIC && likeable.type === TYPES.PRODUCT_TYPE;
      });
    },
    unlikeProducts: function () {
      return this.likeables.filter((likeable) => {
        return likeable.approach === APPROACHES.DO_NOT_LIKE && likeable.type === TYPES.PRODUCT_TYPE;
      });
    },
    like: function () {
      return this.likeables.filter((likeable) => {
        return likeable.approach === APPROACHES.LIKE && likeable.type === TYPES.PRODUCT_TYPE;
      });
    },
  },
}
</script>
<style scoped>
pre {
  background-color: white;
  border: none;
  padding: 0;
  margin: 0;
  font-size: 14px;
  line-height: 21px;
  font-family: Roboto, sans-serif;
  color: rgba(0,0,0,.87);
  white-space: pre-wrap;
}

.preferences-block{
  max-height: 500px;
  overflow-y: auto;
}
</style>
